<div class="chart-wrapper">
    <div class="showDRButton">
        <button id="buttonDRPL" class="mr-5 mb-4 showDLR-button" density="compact" label="Compact Button"
                variant="secondary" data-qaa="buttonDRPL-mobile"
                shape="round" color-variant="default" (click)="showDRList()">
            {{ 'DISPATCH_LIST.SHOW_LIST' | translate }}
        </button>
    </div>
    <div class="container-card outer-level has-shadow"
         style="padding: 24px; height: auto; background-color: #ffffff; border-radius: 8px;">
      <span class="container-title site-row" style="padding-block-end: 16px;">
        <div class="title-style">
          <span class="text-title site-label" style="margin:0"> {{ 'DISPATCH_PERFORMANCE.SITE_INFO.SITE' | translate }} </span>
          <span class="text-subtitle site-name" data-qaa="site_label">{{ activeDispatchText.site }}</span>
        </div>
        <div class="button-style showDRButton-1">
          <button id="buttonDRPL" class="showDLR-button" density="compact" label="Compact Button"
                  variant="secondary" shape="round" color-variant="default" data-qaa="buttonDRPL-desktop"
                  (click)="showDRList()">
            {{ 'DISPATCH_LIST.SHOW_LIST' | translate }}
          </button>
        </div>
      </span>
        <div class="divider-wrapper" style="display: flex; height: 0px; justify-content: center; align-items: center; align-self: stretch;">
            <dsy-divider divider-orientation="horizontal" divider-color="light-grey" style="width: 100%; height: 0px;"
                         class="divider">
            </dsy-divider>
        </div>
        <div class="container-titleList">
            <div class="container-title">
                <div>
                    <span class="text-titleList">{{ 'DISPATCH_PERFORMANCE.SITE_INFO.DATE_TIME' | translate }}</span>
                    <span class="text-subtitleList dispatch-details-summary">{{ activeDispatchText.startAndEndTime }}</span>
                </div>
                <mat-icon *ngIf="isDispatchDetailsOpen" class="dropdown-chip-close-icon" (click)="isDispatchDetailsOpen = false">keyboard_arrow_up</mat-icon>
                <mat-icon *ngIf="!isDispatchDetailsOpen" class="dropdown-chip-close-icon" (click)="isDispatchDetailsOpen = true">keyboard_arrow_down</mat-icon>
            </div>
            <div *ngIf="isDispatchDetailsOpen">
                <div *ngIf="eventNode && (eventNode.site_to_registration_map?.length ?? 0) > 1">
                    <span class="text-titleList"> {{ 'DISPATCH_PERFORMANCE.SITE_INFO.SITE_DETAILS' | translate }} </span>
                    <span class="text-subtitleList" data-qaa="site_details_label">{{ activeDispatchText.siteDetails }} </span>
                </div>
                <div>
                    <span class="text-titleList"> {{ 'DISPATCH_PERFORMANCE.SITE_INFO.PROGRAM' | translate }} </span>
                    <span class="text-subtitleList" data-qaa="program_label">{{ activeDispatchText.program }}</span>
                </div>
                <div>
                    <span class="text-titleList"> {{ 'DISPATCH_PERFORMANCE.SITE_INFO.ORGANIZATION' | translate }} </span>
                    <span class="text-subtitleList" data-qaa="organization_label">{{ activeDispatchText.organization_name }}</span>
                </div>
            </div>
        </div>
        <div class="details-divider">
            <dsy-divider divider-orientation="horizontal" divider-color="light-grey" style="width: 100%;"></dsy-divider>
        </div>
        <div class="banner-wrapper" *ngIf="product">
            <div class="has-border has-padding" style="display: flex; align-items: center; gap:16px"
                 [ngStyle]="{'background-color': bannerDetails.backgroundColor, 'border': '2px solid ' + bannerDetails.borderColor}">
                 <dsy-icon class="banner-icon" [name]="bannerDetails.iconName" [color]="bannerDetails.borderColor" library="bootstrap"></dsy-icon>
                <div>
                    <h2 class="toast-message-title">{{ bannerDetails.title }}</h2>
                    <p class="toast-message-subtitle">{{ bannerDetails.description }}</p>
                </div>
            </div>
        </div>
        <div>
            <div style="display:flex; justify-content: space-between;padding-block-end: 16px;" *ngIf="chart && !isChartLoading">
                <div class="d-flex gap-2" style="height: max-content;">
                    <div (click)="addRemoveLine(0)" *ngIf="!showLineChart(0)" class="plotBand line-legend text-truncate"
                        [ngClass]="{'plotBand-hidden': !chart.isDatasetVisible(0)}">
                        <div class="line-baseline"></div>
                        <span>{{ 'INTERVAL_GRAPH.TOOLTIP_BASELINE' | translate }}</span>
                    </div>
                    <div (click)="addRemoveLine(1)" *ngIf="!showLineChart(1)" class="plotBand line-legend text-truncate"
                        [ngClass]="{'plotBand-hidden': !chart.isDatasetVisible(1)}">
                        <div class="line-demand"></div>
                        <span>{{ 'INTERVAL_GRAPH.TOOLTIP_DEMAND' | translate }}</span>
                    </div>
                    <div (click)="addRemoveLine(2)" *ngIf="!showLineChart(2)" class="plotBand line-legend text-truncate"
                        [ngClass]="{'plotBand-hidden': !chart.isDatasetVisible(2)}">
                        <div class="line-target"></div>
                        <span>{{ 'INTERVAL_GRAPH.TOOLTIP_TARGET' | translate }}</span>
                    </div>
                </div>
                <div *ngIf="!isMobile" style="display: flex;  flex-direction: row-reverse; align-items: center; position: relative;">
                    <dsy-button button-style="padding: 8px; border-radius: 8px;" style="background-color:#F7F8FB; border-radius: 8px;"  variant="tertiary" (click)="openListDownload()" #openListDownloadButton>
                        <dsy-icon size="14px" color="primary" name="more_horiz" library="material" color="#5738FF"></dsy-icon>
                    </dsy-button>
                    <div slot="custom-dropdown-list-element" *ngIf="listDownload" class="listDownload" #listDownloadDropdown>
                        <dsy-list-element *ngFor="let dropdownEntry of dropdownDownload" >
                            <span class="text-link" (click)="downloadChart(dropdownEntry)">{{ dropdownEntry }}</span>
                        </dsy-list-element>
                    </div>
                </div>
            </div>
            <div *ngIf="isChartLoading" class="chart-loading-state">
                <div class="loading-spinner"></div>
            </div>
            <div style="width: 100%; padding-block-end: 16px" class="chart-container" [ngClass]="{'chart-hidden': isChartLoading}">
                <canvas id="ADChart">{{ chart }}</canvas>
            </div>
        </div>
        <div class="d-flex flex-wrap align-content-start justify-content-center gap-4" style="padding-block-end: 24px;"
             *ngIf="chart">
            <div *ngIf="viewModel?.from && viewModel?.to && locale !== 'pl-pl'" class="plotBand-circle">
                <div class="circle-ramp-period"></div>
                {{ 'INTERVAL_GRAPH.LEGEND_RAMP_PERIOD' | translate }}
            </div>
            <div *ngIf="viewModel?.show_baseline_adjustment" class="plotBand-circle">
                <div class="circle-baseLine-adjustment"></div>
                {{ 'INTERVAL_GRAPH.LEGEND_BASELINE_ADJ' | translate }}
            </div>
        </div>
    </div>
    <div style="padding-top:16px">
        <!-- Dispatch Participation Info -->
        <div class="container-card outer-level has-shadow"
             style=" height: 100%; background-color: #ffffff; border-radius: 8px; padding:24px; min-height: 80px;">
      <span class="container-title-dispatch-info">
        <div class="dispatch-info-text"> <span class="text-title"> {{ 'DISPATCH_PERFORMANCE.PARTICIPATION_INFO' | translate }} </span> </div>
        <dsy-icon name={{iconName}} library="system" size="12px"
                  class="dropdown-chip-open-icon icon-style-dispatch-info" data-qaa="dispatch_participation_info_icon"
                  (click)="openDispatch ? closeDispatchInfo() : openDispatchInfo()">
        </dsy-icon>
      </span>
            <div *ngIf="openDispatch" class="container-fluid">
                <div class="row row-gap-3">
                    <!-- Reduction plan -->
                    <div class="col-12 col-lg-6">
                        <div class="container-card outer-level has-shadow d-flex flex-column"
                             style=" height: 100%; background-color: #F7F8FB; border-radius: 8px; padding: 24px;">
                                <h2 class="text-title" data-qaa="erp-title" style="padding-block-end: 16px; margin:0">
                                    {{ 'DISPATCH_PERFORMANCE.REDUCTION_PLAN.HEADER' | translate }}
                                </h2>
                                <div *ngIf="isRegistrationLoading" class="section-loading-state">
                                    <div class="loading-spinner-small"></div>
                                </div>
                                <ng-container *ngIf="!isRegistrationLoading">
                                    @let noEnergyReductionPlan = !activeDispatchText.energy_reduction_plan;
                                    <div class="erpContainer erpContacts" [ngStyle]="{ 'height': '100%',  'justify-content':noEnergyReductionPlan? 'center':'start' }">
                                        <p style="margin: 0;" [ngClass]="{'erpContacts-center':noEnergyReductionPlan}" data-qaa="erp" >
                                            {{ noEnergyReductionPlan? ('DISPATCH_PERFORMANCE.REDUCTION_PLAN.NO_REDUCTION_PLAN'|translate): activeDispatchText.energy_reduction_plan}}
                                        </p>
                                    </div>
                                </ng-container>
                        </div>
                    </div>
                    <!-- Contacts -->
                    <div class="col-12 col-lg-6">
                        <div class="container-card outer-level has-shadow d-flex flex-column"
                             style="background-color: #F7F8FB; border-radius: 8px; padding: 24px; height: 100%;">
                            <h2 class="text-title" style="padding-block-end: 16px;margin:0"> {{ 'DISPATCH_PERFORMANCE.CONTACTS.HEADER' | translate }} </h2>
                            <div *ngIf="isContactsLoading" class="section-loading-state">
                                <div class="loading-spinner-small"></div>
                            </div>
                            <ng-container *ngIf="!isContactsLoading">
                                <div style="flex:1" *ngFor="let contact of contacts | slice: 0:visibleCount; let i = index">
                                <dsy-divider divider-orientation="horizontal" divider-color="light-grey"
                                             style="width:100%; padding-block-start: 16px; padding-block-end: 16px; display: flex;"
                                             *ngIf="i > 0 && i < (visibleCount)"></dsy-divider>
                                <ol class="list-group">
                                    <li class="text-title d-flex">{{ 'DISPATCH_PERFORMANCE.CONTACTS.NAME' | translate }} <span class="text-subtitleList"
                                                                              style="margin-left: 5px">{{ contact?.full_name }}</span>
                                        <div class="primary" *ngIf="contact.twentyfour_seven_contact">{{ 'DISPATCH_PERFORMANCE.CONTACTS.TWENTY_FOUR_SEVEN' | translate }}</div>
                                        <div class="primary" *ngIf="contact.primary_contact">{{ 'DISPATCH_PERFORMANCE.CONTACTS.PRIMARY' | translate }}</div>
                                    </li>
                                    <li class="text-title" *ngIf="contact.title">{{ 'DISPATCH_PERFORMANCE.CONTACTS.TITLE' | translate }} <span
                                            class="text-subtitleList">{{ contact?.title }}</span>
                                    </li>
                                    <li class="text-title" *ngIf="contact.phone?.phone_number">{{ 'DISPATCH_PERFORMANCE.CONTACTS.PHONE' | translate }} <span
                                            class="text-subtitleList">{{formatPhoneNumber(contact)}}</span>
                                    </li>
                                    <li class="text-title" *ngIf="contact.phone?.phone_number">{{ 'DISPATCH_PERFORMANCE.CONTACTS.MOBILE_PHONE' | translate }} <span
                                            class="text-subtitleList">{{formatPhoneNumber(contact)}}</span>
                                    </li>
                                    <li class="text-title break-text">
                                        {{ 'DISPATCH_PERFORMANCE.CONTACTS.EMAIL' | translate }} 
                                        <div style="display: inline-block; position: relative;">
                                            <dsy-button variant="link" button-style="text-decoration: none; padding: 0;" (click)="onEmailClicked(contact)"
                                                (rightClick)="onEmailRightClicked(contact)">
                                                <span class="text-subtitleList" style="color:#5738FF;">
                                                    {{ contact?.email?.email_address }}
                                                </span>
                                            </dsy-button>
                                        
                                            <div class="custom-tooltip" *ngIf="contact.email?.id && activeTooltipEmailId === contact.email.id">
                                                {{ 'DISPATCH_PERFORMANCE.CONTACTS.COPIED' | translate }}
                                            </div>
                                        </div>
                                            
                                    </li>
                                </ol>
                            </div>
                            <div *ngIf="contacts && contacts.length > 3">
                                <dsy-button class="show-more" density="wide" label="Small Button" icon-side="right"
                                            icon-name="arrow-down"
                                            icon-library="system" icon-size="1em" variant="link" shape=""
                                            color-variant="default" (click)="openMore()"
                                            *ngIf="showMore">
                                    {{ 'DISPATCH_PERFORMANCE.CONTACTS.SHOW_MORE' | translate }}
                                </dsy-button>
                                <dsy-button class="show-more" density="wide" label="Small Button" icon-side="right"
                                            icon-name="arrow-up"
                                            icon-library="system" icon-size="1em" variant="link" shape=""
                                            color-variant="default" (click)="closeMore()"
                                            *ngIf="!showMore">
                                    {{ 'DISPATCH_PERFORMANCE.CONTACTS.SHOW_LESS' | translate }}
                                </dsy-button>
                            </div>
                            <div style=" height: 100%;" *ngIf="contacts.length <= 0">
                                <p class="erpContacts" style="margin: 0;" data-qaa="no_contacts">{{ 'DISPATCH_PERFORMANCE.CONTACTS.NO_CONTACTS' | translate }}</p>
                            </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
